export default __webpack_public_path__ + "static/media/phone_1.0964772f.png";